<div class="container-fluid">
    <app-breadcrumb
        [title]="'Suivi des opérations'"
        [active_item]="'Prise en charge'"
    ></app-breadcrumb>
    <div class="card" [ngStyle]="{ 'border-radius': '10px' }">
        <div class="card-body">
            <div class="row filter_wrapper">
                <div class="col-md-2">
                    <div class="form-group">
                        <label><b>Type opération</b></label>
                        <p-dropdown
                            [options]="listOperations"
                            [showClear]="true"
                            [(ngModel)]="selectedTypeOperation"
                            placeholder="Opération"
                        >
                            <ng-template let-data pTemplate="item">
                                <div class="country-item">
                                    <div>{{ data | titlecase }}</div>
                                </div>
                            </ng-template>
                        </p-dropdown>
                    </div>
                </div>
                <div class="col-md-2">
                    <div class="form-group">
                        <label>
                            <b>{{ firstLevelLibelle }}</b>
                        </label>
                        <p-dropdown
                            [options]="listFirstLevel"
                            optionLabel="fullName"
                            (onChange)="onChangeItem($event)"
                            [showClear]="true"
                            [filter]="true"
                            filterBy="fullName"
                            [placeholder]="firstLevelLibelle"
                        >
                            <ng-template let-data pTemplate="item">
                                <div class="country-item">
                                    <div>
                                        {{ data.fullName }}
                                    </div>
                                </div>
                            </ng-template>
                        </p-dropdown>
                    </div>
                </div>
                <div class="col-md-2">
                    <div class="form-group">
                        <label>
                            <b>{{ secondLevelLibelle }}</b>
                        </label>
                        <p-dropdown
                            [options]="listSecondLevel"
                            optionLabel="fullName"
                            optionLabel="nom"
                            [filter]="true"
                            [(ngModel)]="selectedSecondLevel"
                            [showClear]="true"
                            [placeholder]="secondLevelLibelle"
                        >
                            <ng-template let-data pTemplate="item">
                                <div class="country-item">
                                    <div>
                                        {{ data.fullName }}
                                    </div>
                                </div>
                            </ng-template>
                        </p-dropdown>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="form-group">
                        <label><b>N° Ligne</b> </label>
                        <input
                            type="text"
                            pInputText
                            [(ngModel)]="selectedTransaction"
                        />
                    </div>
                </div>
                <div class="col-md-2">
                    <div class="form-group">
                        <label><b>Statut</b> </label>
                        <p-dropdown
                            [options]="listStatutTransactions"
                            [showClear]="true"
                            [(ngModel)]="selectedStatut"
                            placeholder="Statut"
                        >
                            <ng-template let-data pTemplate="item">
                                <div class="country-item">
                                    <div>{{ data | titlecase }}</div>
                                </div>
                            </ng-template>
                        </p-dropdown>
                    </div>
                </div>
                <div
                    class="p-0"
                    [ngStyle]="{ width: '4rem' }"
                    *ngIf="!secondFilter"
                >
                    <label [ngStyle]="{ opacity: '0' }">Actions</label> <br />
                    <p-button
                        styleClass="p-button-success"
                        icon="pi pi-filter"
                        (click)="onFilter()"
                        [disabled]="isFilter()"
                    ></p-button>
                </div>
                <div class="p-0" [ngStyle]="{ width: '4rem' }">
                    <label [ngStyle]="{ opacity: '0' }">Actions</label> <br />
                    <p-button
                        *ngIf="!secondFilter"
                        (click)="showSecondFilter()"
                        styleClass="p-button-dark"
                        icon="pi pi-plus"
                    ></p-button>
                    <p-button
                        *ngIf="secondFilter"
                        (click)="showSecondFilter()"
                        styleClass="p-button-dark"
                        icon="pi pi-minus"
                    ></p-button>
                </div>
            </div>
            <!--------------------Second-------------Filter--------->
            <div
                class="row filter_wrapper"
                style="padding-top: 0.7rem"
                *ngIf="secondFilter"
            >
                <div class="col-md-2">
                    <label class="block"><b>Date début</b></label>
                    <p-calendar
                        [(ngModel)]="filterDateStart"
                        [showIcon]="true"
                        (ngModelChange)="changeDateStart($event)"
                        dateFormat="dd-mm-yy"
                    ></p-calendar>
                </div>
                <div class="col-md-2">
                    <label class="block"><b>Date fin </b></label>
                    <p-calendar
                        [(ngModel)]="filterDateEnd"
                        [showIcon]="true"
                        [showClear]="true"
                        (ngModelChange)="changeDateEnd($event)"
                        dateFormat="dd-mm-yy"
                    ></p-calendar>
                </div>
                <div class="p-0" [ngStyle]="{ width: '4rem' }">
                    <label [ngStyle]="{ opacity: '0' }">Actions</label> <br />
                    <p-button
                        styleClass="p-button-success"
                        icon="pi pi-filter"
                        (click)="onFilter()"
                        [disabled]="isFilter()"
                    ></p-button>
                </div>
            </div>
            <div class="mt-4">
                <p-table
                    #dt
                    [value]="listTraitemants"
                    [rows]="10"
                    [paginator]="true"
                    [globalFilterFields]="[
                        'id',
                        'date',
                        'num_transaction',
                        'dr',
                        'exploitation',
                        'operation',
                        'code_erreur',
                        'message',
                        'affectation',
                        'intervenant'
                    ]"
                    responsiveLayout="scroll"
                    [rowHover]="true"
                    dataKey="id"
                    currentPageReportTemplate="Affichage de {first} à {last} des {totalRecords} données"
                    [showCurrentPageReport]="true"
                    responsiveLayout="scroll"
                    scrollable="true"
                    scrollHeight="flex"
                    width="100%"
                    class="responsive-claims-table"
                >
                    <ng-template pTemplate="caption">
                        <div class="seach_and_btns p-0">
                            <div>
                                <button
                                    pButton
                                    pRipple
                                    label="Rafraîchir"
                                    icon="pi pi-refresh"
                                    class="p-button-secondary"
                                    (click)="OnRefresh()"
                                ></button>
                                <button
                                    pButton
                                    pRipple
                                    label="Exporter"
                                    icon="pi pi-download"
                                    class="p-button-helf ms-3"
                                ></button>
                            </div>
                            <div>
                                <span class="p-input-icon-left">
                                    <i class="pi pi-search"></i>
                                    <input
                                        pInputText
                                        type="text"
                                        (input)="
                                            dt.filterGlobal(
                                                $event.target.value,
                                                'contains'
                                            )
                                        "
                                        placeholder="Recherche..."
                                    />
                                </span>
                                <button
                                    pButton
                                    pRipple
                                    label="Affecter"
                                    icon="pi pi-arrow-right"
                                    class="p-button-success ms-3"
                                ></button>
                            </div>
                        </div>
                    </ng-template>
                    <br />
                    <ng-template pTemplate="header">
                        <tr>
                            <th
                                class="text-center"
                                [style]="{ width: '1.5rem' }"
                            >
                                #
                            </th>
                            <th class="text-center">Date / Heure</th>
                            <th
                                class="text-center"
                                [ngStyle]="{ width: '200px' }"
                            >
                                N° Ligne
                            </th>
                            <th class="text-center">{{ firstLevelLibelle }}</th>
                            <th class="text-center">
                                {{ secondLevelLibelle }}
                            </th>
                            <th class="text-center">Service</th>
                            <th class="text-center">Code R.</th>
                            <th
                                pTooltip="Details de rapport"
                                tooltipPosition="top"
                            >
                                Détails R.
                            </th>
                            <th
                                pTooltip="Details de rapport"
                                tooltipPosition="top"
                            >
                                Affectation
                            </th>
                            <th class="text-center">Statut</th>
                            <th
                                class="text-center"
                                [ngStyle]="{ width: '150px' }"
                                pTooltip="Date de traitement"
                                tooltipPosition="top"
                            >
                                Date T.
                            </th>
                            <th
                                pTooltip="Date de traitement"
                                tooltipPosition="top"
                            >
                                Intervenant
                            </th>
                            <th class="text-center">
                                <p-checkbox
                                    [binary]="true"
                                    [(ngModel)]="checkedAllConsumers"
                                ></p-checkbox>
                            </th>
                        </tr>
                    </ng-template>
                    <ng-template let-i="rowIndex" pTemplate="body" let-prise>
                        <tr>
                            <td class="text-center">{{ this.offset + i }}</td>
                            <td [style]="{ width: '10rem' }">
                                {{ transaction?.created_at }}
                            </td>
                            <td
                                class="cursor-pointer text-center"
                                (click)="
                                    copyTransaction(transaction.transaction)
                                "
                            >
                                {{ transaction.transaction }}
                            </td>
                            <td class="text-center">
                                {{ transaction?.niveau_1?.nom }}
                            </td>
                            <td class="text-center">
                                {{ transaction?.niveau_2?.nom }}
                            </td>
                            <td class="text-center">
                                {{
                                    getTitleForm(
                                        transaction?.operation ?? 'N/A'
                                    )
                                }}
                            </td>
                            <td class="text-center">
                                <span
                                    [ngStyle]="{ 'font-size': '16px' }"
                                    [class.text-white]="
                                        getCodeRapport(
                                            transaction?.code_rapport
                                        ) === '200' ||
                                        getCodeRapport(
                                            transaction?.code_rapport
                                        ) === 'false'
                                    "
                                    [class.badge-dark]="
                                        getCodeRapport(
                                            transaction?.code_rapport
                                        ) === '100'
                                    "
                                    [class.badge-info]="
                                        getCodeRapport(
                                            transaction?.code_rapport
                                        ) === '102'
                                    "
                                    [class.badge-success]="
                                        getCodeRapport(
                                            transaction?.code_rapport
                                        ) === '200'
                                    "
                                    [class.badge-danger]="
                                        getCodeRapport(
                                            transaction?.code_rapport
                                        ) === 'false'
                                    "
                                    class="badge"
                                >
                                    {{ transaction.code_rapport }}
                                </span>
                            </td>
                            <td
                                class="cursor-pointer"
                                [innerHTML]="transaction?.message"
                                (click)="showDialog(transaction)"
                                pTooltip="cliquer pour voir"
                                tooltipPosition="top"
                            >
                                {{ truncateString(transaction?.message, 20) }}
                            </td>
                            <td></td>
                            <td class="text-center">
                                <span
                                    [ngStyle]="{ 'font-size': '16px' }"
                                    class="badge"
                                    [class.badge-success]="
                                        transaction?.affectation === 'affecté'
                                    "
                                    [class.badge-info]="
                                        transaction?.affectation ===
                                        'auto-affecté'
                                    "
                                >
                                    {{ transaction?.affectation }}
                                </span>
                            </td>
                            <td class="text-center">
                                <span
                                    [ngStyle]="{ 'font-size': '16px' }"
                                    class="badge"
                                    [class.badge-dark]="
                                        transaction?.statut === stateSoumis
                                    "
                                    [class.badge-info]="
                                        transaction?.statut === stateTraite
                                    "
                                    [class.badge-success]="
                                        transaction?.statut === stateCloture
                                    "
                                >
                                    {{ transaction.statut }}
                                </span>
                            </td>
                            <td [style]="{ width: '10rem' }">
                                {{
                                    transaction?.statut === stateTraite
                                        ? transaction?.date_traitement
                                        : 'N/A'
                                }}
                            </td>
                            <td class="text-center">
                                <span>
                                    {{ transaction?.intervenant_nom }}
                                    {{ transaction?.intervenant_prenoms }}
                                </span>
                            </td>
                            <td>
                                <p-checkbox
                                    name="groupname"
                                    [value]="data.id"
                                    [binary]="true"
                                    [(ngModel)]="data.checked"
                                ></p-checkbox>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>
    </div>
</div>
